import { render, staticRenderFns } from "./pdf-translator.vue?vue&type=template&id=4d318fbc&scoped=true&"
import script from "./pdf-translator.vue?vue&type=script&lang=ts&"
export * from "./pdf-translator.vue?vue&type=script&lang=ts&"
import style0 from "./pdf-translator.vue?vue&type=style&index=0&id=4d318fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d318fbc",
  null
  
)

export default component.exports